// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"33":"9cde492b","486":"657afaac","733":"d229b3e8"}[chunkId] + ".chunk.css";
};